/* eslint-disable react/prop-types */
import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useMergeState } from 'irmlib/hooks'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as gdeTransactionLite from '../../../services/firestore/gdeTransactionsLite'
import { setBusy, clearBusy, openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
// import { TextField, Select, CancelButton, SaveButton, Autocomplete } from '../../../irmlib/src/components/FormControls'
import { Label, ThemeButton } from 'irmlib/components/Controls'
import { YDivider } from 'irmlib/styles'
import { errorToast, successToast } from '../../../common/functions'
import { Button, Typography } from '@material-ui/core'
import { Grid, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material'
import styled from 'styled-components'
import RequestTemplateFormat from '../Template/RequestListTemplate.jsx'
import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
import { storage } from '../../../utils/firestore'
import * as constants from '../../../irmlib/src/common/constants'
import { InputFileUploadButton } from './UploadButton.jsx'
// import { ContactSupportOutlined } from '@material-ui/icons'
// import { pagePadding } from '../../AppControl/constants.js'
import CloseIcon from '@mui/icons-material/Close'
import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { getUser } from '../../../redux/global.js'

const BottomPaddedButton = props =>
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>

const VerticalDivider = () =>
  <YDivider height='20px' />

// const ErrorLabel = styled.label`
//     display: flex
//     width: 100%
//     justify-content: flex-end
//     color: red
//     margin-top: 5px
//     font-size: 11px
// `
const ZoomTool = styled.div`
  position: absolute ;
  z-index: 1 ;
  background-color: rgb(255, 255, 255, 0.8);
  border-radius: 5px;
  box-shadow: 1px 1px 2px black;
  /* border: 1px solid red; */
`

const initialSate = {
  selectedImage: false,
  selectedImageGsPath: false,
  error: '',
  templateData: [],
  newTemplateId: ''
}

export const UpdateRefImage = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const { workerId } = getUser()
  // const tableRef = useRef()
  const [isDialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    setDialogOpen(true) // Open dialog on component mount
  }, [])

  const setError = (value) => {
    setState({ error: value })
  }

  const ContentForDialogBox = () => {
    return (<>
      <Box sx={{ flexGrow: 1, minHeight: 300 }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                  <>
                    <Controls />
                    <TransformComponent>
                      <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                        {rowData.currentImageURL !== ''
                          ? <img src={rowData.currentImageURL} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />
                          : <Label style={{ width: '100%', height: 250 }}></Label>
                        }
                      </div>
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            </Box>
            <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                  <>
                    <Controls />
                    <TransformComponent>
                      <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                        {getState().selectedImage &&
                          <img src={getState().selectedImage} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                      </div>
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            </Box>
            <Typography variant="body1">
              <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats={['JPG', 'JPEG']} />
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>)
  }
  const ButtonsForSaveAndAssignJob = (props) => (
    <>
      <BottomPaddedButton color="primary" variant="outlined" onClick={onCancel}>{t('buttons.cancel')}</BottomPaddedButton>
      <Button variant="contained" color="primary" disabled={!getState()?.selectedImage.length} onClick={postService}>{t('buttons.update')}</Button>
    </>
  )

  const onCancel = () => {
    setDialogOpen(false) // Close the dialog
    onClose()
  }

  const handleImageUpload = async (value) => {
    if (value) {
      setBusy()
      const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
      uploadBytes(imageRef, value)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((url) => {
              const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
              setState({
                selectedImage: url,
                selectedImageGsPath: gspath,
              })
              setError('')
              clearBusy()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error.message)
              setError(t('error.imageUploadFail'))
              clearBusy()
            })
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error.message)
          setError(t('error.imageUploadFail'))
          clearBusy()
        })
    }
  }
  const postService = async postObject => {
    const parentActivityId = rowData.activityId
    const activityDetails = await gdeTransactions.getActivityByID(parentActivityId)
    const initialStatus = activityDetails.status
    let newStat
    if (initialStatus === constants.activityStatus.pending || initialStatus === constants.activityStatus.inProgress) {
      newStat = initialStatus
    } else {
      newStat = false
    }
    // const activityDoc = gdeTransactions.getActivityByID(parentActivityId)
    if (getState().selectedImage) {
      const activityData = {
        imgReference: getState().selectedImage,
        imgReferenceURI: getState().selectedImageGsPath,
        status: 'In Progress',
        isPublished: false,
        isProcessed: false,
        updateTS: (new Date()).toISOString(),
      }
      await gdeTransactions.updateActivityData(parentActivityId, activityData)
      const imageData = {
        idp: {
          statusCode: '',
          status: '',
          exception: ''
        },
        idpResponse: {},
        isPublished: false,
        isProcessed: false,
        processedAt: '',
        publishedAt: '',
        messageId: '',
        idp_message_id: '',
        status: constants.activityStatus.submitted,
        updateTS: (new Date()).toISOString(),
        imgReference: getState().selectedImage,
        imgReferenceURI: getState().selectedImageGsPath,
      }
      await gdeTransactions.getImagesAndUpdate(parentActivityId, imageData, newStat)
      successToast({ message: t('toast.refImageUpdate'), title: t('toast.success') })
      onCancel()
    } else {
      setError('Please upload an image.')
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.boxId })}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#58595B',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px' }}>
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForSaveAndAssignJob />
      </DialogActions>
    </Dialog>
  )
}

UpdateRefImage.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateTemplate = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const tableRef = useRef()

  useEffect(() => {
    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox />,
      buttons: <ButtonsForSaveAndAssignJob update={onTemplateSelection} />,
      closeX: false
    })
  }, [])

  const ContentForDialogBox = (props) => {
    return (
      <>
        <RequestTemplateFormat
          tableRef={tableRef}
          getPageData={getRequestFields}
          title={getState().templateName}
          isEdit={false}
          getState={getState}
          selectedRecord={onCheckBoxSelection}
        />
      </>
    )
  }

  const onCheckBoxSelection = async (requestId) => {
    if (requestId && requestId !== getState()?.newTemplateId) {
      setState({
        newTemplateId: requestId
      })
    }
  }
  const ButtonsForSaveAndAssignJob = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>buttons.cancel</BottomPaddedButton>
      <Button variant="contained" color="primary" onClick={props.update}>{t('buttons.select')}</Button>
    </>

  ButtonsForSaveAndAssignJob.propTypes = {
    update: PropTypes.func
  }

  const onCancel = () => {
    closeGeneralDialog()
    onClose()
  }

  const getRequest = async () => {
    const data = { accountLevel1: rowData.customer }
    const requests = await gdeTransactions.getRequests(data)
    const requestList = []
    requests.forEach((doc) => {
      requestList.push(doc.data())
    })
    setState({
      templateData: requestList,
    })
  }

  const getRequestFields = async () => {
    await getRequest()
    const fields = getState().templateData
    
    fields.sort((a, b) => {
      return (new Date(b.createdTS)) - (new Date(a.createdTS))
    })
    
    const resultPromises = fields.map(doc => {
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })

      return gdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.requestId,
          requestFields: templateFields,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          imgReference: doc.imgReference
        }
      })
    })
    const result = await Promise.all(resultPromises)
    return result
  }

  const onTemplateSelection = async () => {
    if (getState().newTemplateId !== '') {
      const requestData = await gdeTransactionLite.getTemplateById(getState().newTemplateId)
      postService(requestData)
      successToast({ message: t('toast.templateUpdate'), title: t('toast.success') })
    } else {
      errorToast({ message: t('toast.selectTemplate'), isBlocking: false, closeIcon: true })
    }
  }

  const postService = async requestData => {
    const parentActivityId = rowData.activityId
    const activityDetails = await gdeTransactions.getActivityByID(parentActivityId)
    const initialStatus = activityDetails.status
    const activityData = {
      template: requestData?.template,
      status: 'In Progress',
      isPublished: false,
      isProcessed: false,
      updateTS: (new Date()).toISOString(),
      templateLocked: {},
    }
    let newStat
    if (initialStatus === constants.activityStatus.pending || initialStatus === constants.activityStatus.inProgress) {
      newStat = initialStatus
    } else {
      newStat = false
    }
    await gdeTransactions.updateActivityData(parentActivityId, activityData)
    onCancel()
    const imageData = {
      idp: {
        statusCode: '',
        status: '',
        exception: ''
      },
      idpResponse: {},
      isPublished: false,
      isProcessed: false,
      processedAt: '',
      publishedAt: '',
      messageId: '',
      idp_message_id: '',
      status: constants.activityStatus.submitted,
      updateTS: (new Date()).toISOString(),
      template: requestData?.template,
      templateLocked: {},
    }
    await gdeTransactions.getImagesAndUpdate(parentActivityId, imageData, newStat)
  }

  return null
}

UpdateTemplate.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateBox = (props) => {
  const { rowData, onClose } = props
  const { t } = useTranslation()
  // const [state, setState, getState] = useMergeState(initialSate)
  // const tableRef = useRef()
  const [isDialogOpen, setDialogOpen] = useState(false)
  const handleOpenDialog = () => {
    setDialogOpen(true)
  }


  const ContentForDialogBox = () => (
    <Box>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px', fontSize: '0.88rem' }}>
        <strong>{`${t('smartCatalog.plsNote')}`}</strong>{`${t('smartCatalog.plsNoteMsg1')}`}<strong>{rowData.boxId}</strong>{`${t('smartCatalog.plsNoteMsg2')}`}
      </Typography>
    </Box>
  )

  const ButtonsForSaveAndAssignJob = props => (
    <>
      <Button color="primary" variant="outlined" onClick={onCancel}>{t('buttons.cancel')}</Button>
      <Button variant="contained" color="primary" onClick={postService}>{t('buttons.Continue')}</Button>
    </>
  )

  const onCancel = () => {
    setDialogOpen(false)
    onClose()
  }

  const postService = async postObject => {
    const parentActivityId = rowData.activityId
    const activityData = {
      status: 'pending',
      isPublished: false,
      isProcessed: false,
      updateTS: (new Date()).toISOString(),
      isReopen: true,
      isRetake: false,
      isException: false,
      wmsStatus: 'Pending',
      flatFileDetails: {},
      uploadTs: '',
      exceptionNote: '',
      isUploaded: false,
      ctFormatErr: 0,
      ctHITLReject: 0,
      ctIDPFail: 0
    }
    await gdeTransactions.updateActivityData(parentActivityId, activityData)
    onCancel()
    successToast({ message: t('toast.boxReopen'), title: t('toast.success') })
  }

  useEffect(() => {
    handleOpenDialog()
  }, [])

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={onCancel}
        sx={{
          '& .MuiDialog-paper': {
            maxHeight: '80vh',
            width: 'auto',
            maxWidth: '80%',
            overflow: 'visible',
          },
          '& .MuiDialogContent-root': {
            padding: '16px',
            overflow: 'visible',
          },
        }}
      >
        <DialogTitle>
          {t('templates.boxReopenTitle', { boxId: rowData.boxId })}
          <IconButton
            edge="end"
            color="inherit"
            onClick={onCancel}
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#58595B',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'visible', paddingBottom: '0px' }}>
          <ContentForDialogBox />
        </DialogContent>
        <DialogActions>
          <ButtonsForSaveAndAssignJob />
        </DialogActions>
      </Dialog>
    </>
  )
}
  
UpdateBox.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const RetakeImageBox = (props) => {
  const { rowData, onClose } = props
  const { t } = useTranslation()
  const [isDialogOpen, setDialogOpen] = useState(false)
  const handleOpenDialog = () => {
    setDialogOpen(true)
  }

  const ContentForDialogBox = () => (
    <Box>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px', fontSize: '0.88rem' }}>
        <strong>{`${t('smartCatalog.plsNote')}`}</strong>{`${t('smartCatalog.plsNoteMsg1_retakeImage')}`}<strong>{rowData.boxId}</strong>{`${t('smartCatalog.plsNoteMsg2_retakeImage')}`}
      </Typography>
    </Box>
  )
  const ButtonsForSaveAndAssignJob = props => (
    <>
      <Button color='primary' variant='outlined' onClick={onCancel}>{t('buttons.cancel')}</Button>
      <Button variant="contained" color="primary" onClick={postService}>{t('buttons.Continue')}</Button>
    </>
  )
  
  
  const onCancel = () => {
    setDialogOpen(false)
    onClose()
  }

  const postService = async postObject => {
    const parentActivityId = rowData.activityId
    const activityData = {
      isRetake: true,
      status: 'In Progress',
      updateTS: (new Date()).toISOString(),
    }
    // console.log(parentActivityId)
    await gdeTransactions.updateActivityData(parentActivityId, activityData)
    const selectedImageId = rowData.imageId
    const imageData = {
      status: 'Retake',
      updateTS: (new Date()).toISOString(),
    }
    // console.log(JSON.stringify(rowData, null, 2))
    await gdeTransactions.updateImage(selectedImageId, imageData)
    onCancel()
    successToast({ message: t('toast.imageRecapture'), title: t('toast.success') })
  }

  useEffect(() => {
    handleOpenDialog()
  }, [])

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={onCancel}
        sx={{
          '& .MuiDialog-paper': {
            maxHeight: '80vh',
            width: 'auto',
            maxWidth: '80%',
            overflow: 'visible',
          },
          '& .MuiDialogContent-root': {
            padding: '16px',
            overflow: 'visible',
          },
        }}
      >
        <DialogTitle>
          {t('templates.retakeImageTitle', { boxId: rowData.boxId })}
          <IconButton
            edge="end"
            color="inherit"
            onClick={onCancel}
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#58595B',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'visible', paddingBottom: '0px' }}>
          <ContentForDialogBox />
        </DialogContent>
        <DialogActions>
          <ButtonsForSaveAndAssignJob />
        </DialogActions>
      </Dialog>
    </>
  )
}
  
RetakeImageBox.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}


export const ReprocessImage = (props) => {
  const { rowData, onClose } = props
  const { t } = useTranslation()
  
  useEffect(() => {
    openGeneralDialog({
      title: t('templates.reprocessImageTitle', { boxId: rowData.boxId }),
      maxWidth: 'md',
      noTranslateTitle: true,
      message: '',
      buttons: <ButtonsForSaveAndAssignJob update={postService} />,
      closeX: true
    })
  }, [])
  
  const ButtonsForSaveAndAssignJob = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>buttons.cancel</BottomPaddedButton>
      <Button variant="contained" color="primary" onClick={props.update}>{t('buttons.Continue')}</Button>
    </>
  
  ButtonsForSaveAndAssignJob.propTypes = {
    update: PropTypes.func
  }
  
  const onCancel = () => {
    closeGeneralDialog()
    onClose()
  }
  
  const postService = async postObject => {
    const selectedImageId = rowData.imageId
    const imageData = {
      isReprocess: true,
      status: constants.activityStatus.submitted,
      updateTS: (new Date()).toISOString(),
    }
    await gdeTransactions.updateImage(selectedImageId, imageData)
    onCancel()
    successToast({ message: t('toast.imageReprocess'), title: t('toast.success') })
  }
    
  return null
}
ReprocessImage.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateImageTemplate = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const tableRef = useRef()
  
  useEffect(() => {
    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox />,
      buttons: <ButtonsForSaveAndAssignJob update={onTemplateSelection} />,
      closeX: false
    })
  }, [])

  
  const ContentForDialogBox = (props) => {
    return (
      <>
        <RequestTemplateFormat
          tableRef={tableRef}
          getPageData={getRequestFields}
          title={getState().templateName}
          isEdit={false}
          getState={getState} 
          selectedRecord={onCheckBoxSelection}
      />
      </>
    )
  }

  const onCheckBoxSelection = async(requestId) => {
    if (requestId && requestId !== getState()?.newTemplateId) {
      setState({
        newTemplateId: requestId
      })
    }
  }
  const ButtonsForSaveAndAssignJob = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>buttons.cancel</BottomPaddedButton>
      <Button variant="contained" color="primary" onClick={props.update}>{t('buttons.select')}</Button>
    </>
  
  ButtonsForSaveAndAssignJob.propTypes = {
    update: PropTypes.func
  }
  
  const onCancel = () => {
    closeGeneralDialog()
    onClose()
  }
  
  const getRequest = async() => {
    const data = { accountLevel1: rowData.customer }
    const requests = await gdeTransactions.getRequests(data)
    const requestList = []
    requests.forEach((doc) => {
      requestList.push(doc.data())
    })
    setState({
      templateData: requestList,
    })
  }

  const getRequestFields = async () => {
    await getRequest()
    const fields = getState().templateData

    fields.sort((a, b) => {
      return (new Date(b.createdTS)) - (new Date(a.createdTS))
    })
    
    const resultPromises = fields.map(doc => {
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })

      return gdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.requestId,
          requestFields: templateFields,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          imgReference: doc.imgReference
        }
      })
    })
    const result = await Promise.all(resultPromises)
    return result
  }

  const onTemplateSelection = async() => {
    if (getState().newTemplateId !== '') {
      const requestData = await gdeTransactionLite.getTemplateById(getState().newTemplateId)
      postService(requestData)
      successToast({ message: t('toast.templateUpdate'), title: t('toast.success') })
    } else {
      errorToast({ message: t('toast.selectTemplate'), isBlocking: false, closeIcon: true })
    }
  }

  const postService = async requestData => {
    const selectedImageId = rowData.imageId
    const imageData = {
      isReprocess: true,
      status: constants.activityStatus.submitted,
      template: requestData?.template,
      templateLocked: {},
      updateTS: (new Date()).toISOString(),
    }
    await gdeTransactions.updateImage(selectedImageId, imageData)
    onCancel()
    successToast({ message: t('toast.imageReprocess'), title: t('toast.success') })
  }
      
  return null
}

UpdateImageTemplate.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateImgRefImage = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const { workerId } = getUser()
  // const tableRef = useRef()
  const [isDialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    setDialogOpen(true) // Open dialog on component mount
  }, [])

  const setError = (value) => {
    setState({ error: value })
  }

  const ContentForDialogBox = () => {
    return (<>
      <Box sx={{ flexGrow: 1, minHeight: 300 }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                  <>
                    <Controls />
                    <TransformComponent>
                      <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                        {rowData.currentImageURL !== ''
                          ? <img src={rowData.currentImageURL} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />
                          : <Label style={{ width: '100%', height: 250 }}></Label>
                        }
                      </div>
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>

            </Box>
            <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                  <>
                    <Controls />
                    <TransformComponent>
                      <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                        {getState().selectedImage && 
                          <img src={getState().selectedImage} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                      </div>
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>

            </Box>
            <Typography variant="body1">
              <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats = {['JPG', 'JPEG']} />
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>)
  }
  const ButtonsForSaveAndAssignJob = (props) => (
    <>
      <BottomPaddedButton color="primary" variant="outlined" onClick={onCancel}>{t('buttons.cancel')}</BottomPaddedButton>
      <Button variant="contained" color="primary" disabled={!getState()?.selectedImage.length} onClick={postService}>{t('buttons.update')}</Button>
    </>
  )

  const onCancel = () => {
    setDialogOpen(false) // Close the dialog
    onClose()
  }

  const handleImageUpload = async (value) => {
    if (value) {
      setBusy()
      const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
      uploadBytes(imageRef, value)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((url) => {
              const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
              setState({
                selectedImage: url,
                selectedImageGsPath: gspath,
              })
              setError('')
              clearBusy()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error.message)
              setError(t('error.imageUploadFail'))
              clearBusy()
            })
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error.message)
          setError(t('error.imageUploadFail'))
          clearBusy()
        })
    }
  }
  const postService = async postObject => {
    const selectedImageId = rowData.imageId
    if (getState().selectedImage) {
      const imageData = {
        isReprocess: true,
        status: constants.activityStatus.submitted,
        updateTS: (new Date()).toISOString(),
        imgReference: getState().selectedImage,
        imgReferenceURI: getState().selectedImageGsPath,
      }
      await gdeTransactions.updateImage(selectedImageId, imageData)
      successToast({ message: t('toast.refImageUpdate'), title: t('toast.success') })
      onCancel()
    } else {
      setError('Please upload an image.')
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.boxId })}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#58595B',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px' }}>
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForSaveAndAssignJob />
      </DialogActions>
    </Dialog>
  )
}

UpdateImgRefImage.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateImageTemplateAndRef = (props) => {
  const { rowData, onClose } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const tableRef = useRef()

  useEffect(() => {
    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox />,
      buttons: <ButtonsForSaveAndAssignJob update={onTemplateSelection} />,
      closeX: false
    })
  }, [])

  const ContentForDialogBox = (props) => {
    return (
      <>
        <RequestTemplateFormat
          tableRef={tableRef}
          getPageData={getRequestFields}
          title={getState().templateName}
          isEdit={false}
          getState={getState} 
          selectedRecord={onCheckBoxSelection}
        />
      </>
    )
  }

  const onCheckBoxSelection = async (requestId) => {
    if (requestId && requestId !== getState()?.newTemplateId) {
      setState({
        newTemplateId: requestId
      })
    }
  }

  const ButtonsForSaveAndAssignJob = (props) =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>{t('buttons.cancel')}</BottomPaddedButton>
      <Button variant="contained" color="primary" onClick={props.update}>{t('buttons.select')}</Button>
    </>
  
  const getRequest = async () => {
    const data = { accountLevel1: rowData.customer }
    const requests = await gdeTransactions.getRequests(data)
    const requestList = []
    requests.forEach((doc) => {
      requestList.push(doc.data())
    })
    setState({
      templateData: requestList,
    })
  }

  const getRequestFields = async () => {
    await getRequest()
    const fields = getState().templateData
    
    fields.sort((a, b) => {
      return (new Date(b.createdTS)) - (new Date(a.createdTS))
    })
    
    const resultPromises = fields.map(doc => {  
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })

      return gdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.requestId,
          requestFields: templateFields,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          imgReference: doc.imgReference
        }
      })
    })
    const result = await Promise.all(resultPromises)
    return result
  }

  const onTemplateSelection = async () => {
    if (getState().newTemplateId !== '') {
      const requestData = await gdeTransactionLite.getTemplateById(getState().newTemplateId)
      setState({ selectedTemplateData: requestData.template })
      openUpdateRefImageDialog()
    } else {
      errorToast({ message: t('toast.selectTemplate'), isBlocking: false, closeIcon: true })
    }
  }

  
  const onCancel = () => {
    closeGeneralDialog()
    onClose()
  }
  
  const openUpdateRefImageDialog = () => {
    openGeneralDialog({
      title: t('templates.refImageUpdate', { boxId: rowData.boxId }),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <UpdateTemplateRefImage rowData={rowData} selectedTemplateData={getState().selectedTemplateData} onClose={onCancel} />,
      closeX: false
    })
  }
  
  return null
}

UpdateImageTemplateAndRef.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}

export const UpdateTemplateRefImage = (props) => {
  const { rowData, onClose, selectedTemplateData } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const { workerId } = getUser()
  const [isDialogOpen, setDialogOpen] = useState(true)

  const setError = (value) => {
    setState({ error: value })
  }

  const ContentForDialogBox = () => {
    return (
      <>
        <Box sx={{ flexGrow: 1, minHeight: 300 }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {rowData.currentImageURL !== ''
                            ? <img src={rowData.currentImageURL} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />
                            : <Label style={{ width: '100%', height: 250 }}></Label>
                          }
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {getState().selectedImage && 
                            <img src={getState().selectedImage} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1">
                <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats = {['JPG', 'JPEG']} />
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </>
    )
  }

  const ButtonsForSaveAndAssignJob = (props) => (
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>{t('buttons.cancel')}</BottomPaddedButton>
      <Button variant="contained" color="primary" disabled={!getState()?.selectedImage.length} onClick={postService}>{t('buttons.update')}</Button>
    </>
  )
  
  const onCancel = () => {
    setDialogOpen(false)
    onClose()
  }

  const handleImageUpload = async (value) => {
    if (value) {
      setBusy()
      const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
      uploadBytes(imageRef, value)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((url) => {
              const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
              setState({
                selectedImage: url,
                selectedImageGsPath: gspath,
              })
              setError('')
              clearBusy()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.error(error.message)
              setError(t('error.imageUploadFail'))
              clearBusy()
            })
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error.message)
          setError(t('error.imageUploadFail'))
          clearBusy()
        })
    }
  }

  const postService = async (postObject) => {
    const selectedImageId = rowData.imageId
    if (getState().selectedImage) {
      const imageData = {
        isReprocess: true,
        status: constants.activityStatus.submitted,
        template: selectedTemplateData,
        templateLocked: {},
        updateTS: (new Date()).toISOString(),
        imgReference: getState().selectedImage,
        imgReferenceURI: getState().selectedImageGsPath,
      }
      await gdeTransactions.updateImage(selectedImageId, imageData)
      successToast({ message: t('toast.templateAndRefImageUpdate'), title: t('toast.success') })
      onCancel()
    } else {
      setError('Please upload an image.')
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.boxId })}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#58595B',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px' }}>
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForSaveAndAssignJob />
      </DialogActions>
    </Dialog>
  )
}
export const TemplateAndRefOnImgCature = (props) => {
  const { rowData, reffImage, onClose, selectedTemplateData } = props
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const [isDialogOpen, setDialogOpen] = useState(true)
  const { workerId } = getUser()
  // eslint-disable-next-line
  const [refImage, setRefImage] = useState(reffImage || rowData.imgReference)

  const setError = (value) => {
    setState({ error: value })
  }

  const ContentForDialogBox = () => {
    return (
      <>
        <Box sx={{ flexGrow: 1, minHeight: 300 }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {rowData.imgReference !== ''
                            ? <img src={refImage} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />
                            : <Label style={{ width: '100%', height: 250 }}></Label>
                          }
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1">{`${t('smartCatalog.currentRefImg')}`}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ height: '21.5vw', width: '100%', border: '1px solid #c9c9c9' }}>
                <TransformWrapper>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <Controls />
                      <TransformComponent>
                        <div style={{ width: '100%', height: '100%', cursor: 'zoom-in' }}>
                          {getState().selectedImage && 
                            <img src={getState().selectedImage} style={{ width: '100%', height: '21.5vw', minHeight: '50%', minWidth: '300px' }} alt="BoxImage" />}
                        </div>
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </Box>
              <Typography variant="body1">
                <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats = {['JPG', 'JPEG']} />
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </>
    )
  }

  const ButtonsForSaveAndAssignJob = (props) => (
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={onCancel}>{t('buttons.cancel')}</BottomPaddedButton>
      <Button variant="contained" color="primary" disabled={!getState()?.selectedImage.length} onClick={postService}>{t('buttons.update')}</Button>
    </>
  )
  
  const onCancel = () => {
    setDialogOpen(false)
    onClose()
  }

  const handleImageUpload = async (value) => {
    if (value) {
      setBusy()
      const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`)
      uploadBytes(imageRef, value)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((url) => {
              const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
              setState({
                selectedImage: url,
                selectedImageGsPath: gspath,
              })
              setError('')
              clearBusy()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.error(error.message)
              setError(t('error.imageUploadFail'))
              clearBusy()
            })
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error.message)
          setError(t('error.imageUploadFail'))
          clearBusy()
        })
    }
  }

  const postService = async (postObject) => {
    // const selectedImageId = rowData.imageId
    if (getState().selectedImage) {
      setRefImage(getState().selectedImage)
      selectedTemplateData(getState().selectedImage, getState().selectedImageGsPath, rowData?.id)
      onCancel()
    } else {
      setRefImage(rowData.imgReference)
      selectedTemplateData(rowData.imgReference, rowData.imgReferenceURI)
      onCancel()
    }
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80vh',
          width: 'auto',
          maxWidth: '80%',
          overflow: 'hidden',
        },
        '& .MuiDialogContent-root': {
          padding: '16px',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle>
        {t('templates.refImageUpdate', { boxId: rowData.boxId || rowData.id })}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#58595B',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: '0px' }}>
        <ContentForDialogBox />
      </DialogContent>
      <DialogActions>
        <ButtonsForSaveAndAssignJob />
      </DialogActions>
    </Dialog>
  )
}
export const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls()

  return (
    <ZoomTool>
      <IconButton aria-label="zoom in" onClick={() => zoomIn()}>
        <ZoomInIcon />
      </IconButton>
      <IconButton aria-label="zoom out" onClick={() => zoomOut()}>
        <ZoomOutIcon />
      </IconButton>
      <IconButton aria-label="zoom out" onClick={() => resetTransform()}>
        <RestartAltIcon/>
      </IconButton>
    </ZoomTool>
  )
}


export const GenerateFlatFile = (props) => {
  const { rowData, onClose } = props
  const { t } = useTranslation()
  const [isDialogOpen, setDialogOpen] = useState(false)
  const handleOpenDialog = () => {
    setDialogOpen(true)
  }


  const ContentForDialogBox = () => (
    <Box>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px', fontSize: '0.88rem' }}>
        { `${t('smartCatalog.regenerateFlatFileMsg', { boxId: rowData?.boxId })}` }
      </Typography>
    </Box>
  )

  const ButtonsForSaveAndAssignJob = props => (
    <>
      <Button color="primary" variant="outlined" onClick={onCancel}>{t('buttons.cancel')}</Button>
      <Button variant="contained" color="primary" onClick={postService}>{t('buttons.Continue')}</Button>
    </>
  )

  const onCancel = () => {
    setDialogOpen(false)
    onClose()
  }

  const postService = async postObject => {
    const parentActivityId = rowData.activityId
    const activityData = {
      status: 'completed',
      isProcessed: false,
      updateTS: (new Date()).toISOString(),
      wmsStatus: 'Pending',
      flatFileDetails: {},
      uploadTs: '',
      isUploaded: false,
      isUploadInProgress: false
    }
    await gdeTransactions.updateActivityData(parentActivityId, activityData)
      .then(async() => {
        const activityData = {
          isProcessed: true,
          updateTS: (new Date()).toISOString()
        }
        await gdeTransactions.updateActivityData(parentActivityId, activityData)
      })
    onCancel()
    successToast({ message: t('toast.boxFlatFileRegenerated'), title: t('toast.success') })
  }

  useEffect(() => {
    handleOpenDialog()
  }, [])

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={onCancel}
        sx={{
          '& .MuiDialog-paper': {
            maxHeight: '80vh',
            width: 'auto',
            maxWidth: '80%',
            overflow: 'visible',
          },
          '& .MuiDialogContent-root': {
            padding: '16px',
            overflow: 'visible',
          },
        }}
      >
        <DialogTitle>
          {t('templates.boxRegenerateFlatFileTitle')}
          <IconButton
            edge="end"
            color="inherit"
            onClick={onCancel}
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#58595B',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'visible', paddingBottom: '0px' }}>
          <ContentForDialogBox />
        </DialogContent>
        <DialogActions>
          <ButtonsForSaveAndAssignJob />
        </DialogActions>
      </Dialog>
    </>
  )
}
  
GenerateFlatFile.propTypes = {
  rowData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
}